/**
 * Popup Component
 */
export class Popup {
    constructor() {
        this.wrap = document.querySelector('.main-popup-wrap');
        
        if (!this.wrap) return;
        
        this.init();
    }

    init() {
        const bg = document.querySelector('.main-popup-bg');
        const closeButton = document.querySelector('.popup-close');
        const checkbox = document.getElementById('closeCheck');

        // Swiper 초기화 (여러 개일 때만 네비/페이징 의미 있음, 단일은 그대로 1장 표시)
        if (typeof Swiper !== 'undefined') {
            const paginationEl = this.wrap.querySelector('.main-popup-pagination');
            const swiper = new Swiper('.main-popup-slide', {
                slidesPerView: 1,
                spaceBetween: 10,
                speed: 300,
                navigation: {
                    nextEl: '[data-index="next"]',
                    prevEl: '[data-index="prev"]',
                },
                pagination: paginationEl ? {
                    el: paginationEl,
                    clickable: true,
                } : false,
                watchSlidesProgress: true,
            });
        }

        // 팝업 닫기
        const closePopup = () => {
            this.wrap.style.display = 'none';
            if (checkbox && checkbox.checked) {
                const expires = new Date();
                expires.setHours(23, 59, 59, 999);
                document.cookie = `popupClosed=true; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
            }
        };

        if (closeButton) {
            closeButton.addEventListener('click', closePopup);
        }

        if (bg) {
            bg.addEventListener('click', closePopup);
        }

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closePopup();
            }
        });
    }
}

